// Omnix/client/ui/AudienceManager.js
import { ComponentBase } from "../core/ComponentBase.js";

export class AudienceManager extends ComponentBase {
    constructor(config) {
        super(config);
        this.dataCrud = null;
    }

    async initialize() {
        this.dataCrud = await this.createManagedComponent("DataCrud", null, {
            instanceId: `${this.config.instanceId}-crud`,
            rpcClass: "AudienceRpc",
            schemaPath: "collections/omniAudiences",
            title: "Audiences",
            viewConfig: {
                mode: 'grid',
                fields: [
                    { name: 'name', label: 'Audience Name' },
                    { name: 'description', label: 'Description' },
                ],
                toolbar: { create: { enabled: true, label: "New Audience" } }
            },
            formConfig: {
                fields: {
                    name: { type: 'text', label: 'Audience Name', required: true },
                    description: { type: 'textarea', label: 'Description' },
                    rules: {
                        type: 'AudienceRuleBuilder',
                        component: 'AudienceRuleBuilder',
                        label: 'Audience Rules'
                    }
                }
            },
            dataConfig: { autoLoad: false }
        });
        await super.initialize();
    }

    async initAfterLogin() {
        if (this.dataCrud) {
            this.dataCrud.refreshData();
        }
    }

    async render() {
        return await this.dataCrud.render();
    }
}